// If you ever change this logic - you must match it in early API prefetch in index.html

export function urlToAPIFormat(url: string) {
  return url.replace(/^\/rp\//, '/tp/')
}

export function urlFromAPIFormat(url: string) {
  return url.replace(/^\/tp\//, '/rp/')
}
